import { initialState } from '@/Helpers.js';
import IdentityVerification from '@/models/identity-verification/IdentityVerification.js';
import User from '@/models/User.js';
import axios from '@/plugins/axios.js';
import store from '@/store/Index.js';
import { QUIZ_ATTEMPT_ROUTE_NAMES } from '@/utilities/sidebarMenuRoute.js';

export default async (to, from, next) => {
    const quizRoutes = [...QUIZ_ATTEMPT_ROUTE_NAMES, 'manage-quiz-attempts'];
    if (quizRoutes.includes(to.name)) {
        return next();
    }

    if (
        to.name === 'identity-verification-attempt' &&
        !from.name &&
        !initialState('InstitutionSettings.identity_verification_enabled')
    )
        return next({ name: 'home' });

    if (!initialState('InstitutionSettings.identity_verification_enabled')) return next();

    if (to.name === '403' || to.name === 'identity-verification-attempt') return next();

    if (!store.getters['Auth/user']) {
        return next();
    }

    let { user } = store.state.Auth;

    if (!user) {
        user = await axios
            .get('/api/user', { errorHandle: false })
            .then(resp => resp.data.data)
            .catch(e => {
                if (e.response.status >= 400) {
                    next(e);
                }
            });
    }

    if (to.name === 'identity-verification-attempt' && user?.identity_verification_active_id) {
        next();
    }

    if (!store.getters['User/hasActiveIdentityAttempt'] && user?.identity_verification_active_id) {
        await store.dispatch('User/hydrate', user);
        await User.update({ where: user.id, data: { ...user } });
    }

    if (user?.identity_verification_active_id && to.name !== 'identity-verification-attempt') {
        const activeId = user.identity_verification_active_id;

        await IdentityVerification.fetch(activeId, to);

        return next({ name: 'identity-verification-attempt', replace: true });
    }

    if (!user?.identity_verification_active_id && to.name === 'identity-verification-attempt') {
        return next({ name: 'home' });
    }

    return next();
};
